module.exports = __webpack_public_path__ + "img/punto_red_logo_new_small.971d9a0b.png";